(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-slider]').forEach(function(slider){
  const track = slider.querySelector('.slider-track');
  const btnPrev = slider.querySelector('.prev');
  const btnNext = slider.querySelector('.next');
  const items = track.children;
  if (!items.length) return;
  const itemWidth = items[0].offsetWidth;
  let startIndex = 0;
  const visibleCount = 4;
  function update(){
    const offset = startIndex * itemWidth;
    track.scrollTo({left: offset, behavior: 'smooth'});
  }
  btnPrev.addEventListener('click',()=>{
    startIndex = Math.max(startIndex - visibleCount, 0);
    update();
  });
  btnNext.addEventListener('click',()=>{
    if (startIndex + visibleCount < items.length) {
      startIndex += visibleCount;
      update();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
